import { PayloadAction } from '../../../store.model';
import { filterRows } from '../function/filter-rows.function';
import { ActionType } from '../main.action';
import { MainState } from '../main.state';

import { ToggleFilterGroup } from './toggle-filter-group.action';

export function toggleFilterGroupReducer(
    state: MainState,
    action: PayloadAction<
        ActionType.MI2_MAIN__TOGGLE_FILTER_GROUP,
        ToggleFilterGroup
    >,
): MainState {
    try {
        const nextItems = [...state.improvementGroupFilterItems];
        nextItems.forEach((e, ei) => {
            if (e.item.scorecardImprovementGroupId !== action.payload.groupId) {
                return;
            }
            nextItems[ei] = { ...e, selected: !e.selected };
        });

        const nextFilteredDirectReports = filterRows({
            rows: state.rows,
            sortOptions: state.sortOptions,
            currentPerformanceClassFilterItems:
                state.currentPerformanceClassFilterItems,
            previousPerformanceClassFilterItems:
                state.previousPerformanceClassFilterItems,
            improvementGroupFilterItems: nextItems,
        });

        return {
            ...state,
            filteredRows: nextFilteredDirectReports,
            improvementGroupFilterItems: nextItems,
        };
    } catch {
        return {
            ...state,
        };
    }
}
